/**
 * Tagalog.
 *
 * Written the way Filipinos actually write about this: Taglish, with the
 * product words left in English. "Followers", "likes", "refill" and "wallet"
 * are the words used in the market — translating them to "tagasunod" or
 * "pitaka" would read as a machine translation and cost trust, which is the
 * one thing this copy is for.
 */
export default {
  nav: {
    home: 'Home',
    services: 'Mga Serbisyo',
    faq: 'FAQ',
    help: 'Tulong',
    signIn: 'Mag-sign in',
    getStarted: 'Magsimula',
    openPanel: 'Buksan ang panel',
    language: 'Wika',
    currency: 'Pera',
  },

  common: {
    perThousand: 'kada 1,000',
    from: 'Mula {amount} kada 1,000',
    noSubscription: 'Walang subscription',
    neverPassword: 'Hindi kailanman humihingi ng password',
    cancel: 'Kanselahin',
    done: 'Tapos na',
    total: 'Kabuuan',
    rate: 'Presyo',
    range: 'Saklaw',
    starts: 'Magsisimula',
    refill: 'Refill',
    quantity: 'Dami',
    lowest: 'pinakamura',
    services: 'serbisyo',
    platforms: 'platform',
    shownIn: 'Ipinapakita sa {display} sa palitan ngayon · sisingilin sa {platform}',
    chargedIn: 'Sisingilin sa {code}',
    cancelWhilePending: 'habang pending pa ang order',
    notOffered: 'hindi available',
    chargedAs: 'sisingilin bilang {amount}',
  },

  home: {
    refresh: {
      titleA: 'Mga serbisyo sa social media.',
      titleB: 'Malinaw na presyo. Nasusubaybayang order.',
      lede: 'Tingnan ang followers, likes at views para sa TikTok, Instagram at YouTube. Suriin ang presyo, tantiyang delivery at mga kondisyon ng refill bago ka mag-order.',
      eyebrowIdle: 'Tuklasin ang aming mga serbisyo',
      demo: 'Demo ng pagsubaybay sa order',
      demoNote: 'Halimbawang mga order · 60× ang bilis ng animation',
      servicesKey: 'Tuklasin ang katalogo',
      servicesTitle: 'Hanapin ang serbisyong babagay sa iyo.',
      servicesBody: 'Ikumpara ang kasalukuyang presyo at mga kondisyon ng serbisyo bago gumawa ng account. Tantiya lang ang oras ng pagsisimula, hindi garantiya ng pagkumpleto.',
      perThousand: 'kada 1,000',
      minimum: 'Minimum na dami',
      start: 'Tantiyang pagsisimula',
      notListed: 'Hindi nakalista',
      refill: 'Saklaw ng refill',
      days: '{count} araw',
      seeTerms: 'Tingnan ang mga kondisyon ng serbisyo',
      details: 'Tingnan ang detalye ng serbisyo',
      loading: 'Nilo-load ang kasalukuyang mga serbisyo…',
      empty: 'Walang serbisyong maipapakita sa ngayon. Tingnan ang katalogo para sa mga available.',
      currencyNote: 'Tantiya lang ang mga na-convert na presyo. Suriin ang currency ng singil at ang huling total bago magbayad.',
      faqKey: 'Bago ka mag-order',
      faqTitle: 'Alamin ang aasahan.',
      moreAnswers: 'Iba pang sagot sa mga tanong',
      closingTitle: 'Hanapin ang una mong serbisyo.',
      closingBody: 'Ikumpara ang presyo at mga kondisyon. Piliin ang dami kapag handa ka na.',
      steps: {
        chooseTitle: 'Pumili ng serbisyo',
        chooseBody: 'Mag-browse ayon sa platform at ikumpara ang presyo, minimum na dami at saklaw ng refill.',
        reviewTitle: 'Suriin ang detalye',
        reviewBody: 'Ilagay ang iyong public link at dami. Suriin ang total, tantiyang delivery at mga kondisyon ng serbisyo bago mag-confirm.',
        trackTitle: 'Subaybayan ang order mo',
        trackBody: 'Sundan ang naiulat na status sa iyong account. Kontakin ang support kapag huminto ang order o kailangang tingnan ang resulta.',
      },
      faq: {
        deliveryTitle: 'Gaano katagal ang delivery?',
        deliveryBody: 'Nag-iiba ang oras depende sa serbisyo at dami. Ang tantiyang pagsisimula ay kung kailan maaaring magsimula ang delivery, hindi kung kailan ito matatapos. Maaaring may pagkaantala; kontakin ang support kapag lumampas ang order mo sa nakasaad na tantiya.',
        dropsTitle: 'Puwede bang bumaba ang followers o ibang bilang?',
        dropsBody: 'Oo. Maaaring bumaba ang bilang pagkatapos ng delivery. Ang mga serbisyong may saklaw ng refill lang ang puwedeng mapalitan, sa loob ng nakalistang panahon at kondisyon. Walang kasamang kapalit ang mga serbisyong walang refill.',
        refundsTitle: 'Saan napupunta ang mga refund?',
        refundsBody: 'Kapag nakumpirmang kanselado o partial ang order, ibinabalik sa iyong PresenceRise wallet ang kwalipikadong halagang hindi naihatid. Account credit ito, hindi refund sa card mo. Hindi awtomatikong nare-refund ang order na tumatakbo pa dahil lang naantala ito.',
        passwordTitle: 'Kailangan ko bang ibigay ang password ng social media ko?',
        passwordBody: 'Hindi. Gumagamit ang mga order ng public profile o link ng post mo. Huwag kailanman isama ang password o login code mo sa order o mensahe sa support.',
        paymentsTitle: 'Anong mga paraan ng pagbabayad ang magagamit ko?',
        paymentsBody: 'Makikita ang mga available na paraan sa checkout o kapag nagdadagdag ng pondo. Maaari itong mag-iba ayon sa bansa at currency. Suriin ang mga opsyon at anumang bayarin bago magbayad.',
      },
    },
    eyebrow: '{count} serbisyong live sa {platforms} platform',
    eyebrowIdle: 'Tumatanggap na ng order',
    titleA: 'Paglagong',
    titleB: 'nakikita mo.',
    lede: 'Followers, likes, views at subscribers, may presyo kada libo at inihahatid sa pipeline na nakikita mo. Bawat order ay sinusubaybayan nang live, sinusukat pagkatapos, at kusang nirerefund o nirerefill kapag kulang.',
    ctaStart: 'Magsimula nang libre',
    ctaBrowse: 'Tingnan ang mga serbisyo',
    ctaOrder: 'Mag-order',
    delivering: '{count} naghahatid',
    illustration: 'Halimbawa lang, 60× ang bilis',
    figures: {
      services: 'serbisyo',
      platforms: 'platform',
      from: 'mula, kada 1,000',
      refill: 'may refill window',
      remeasured: 'araw na sinusukat muli ang bawat order',
      tickets: 'ticket na kailangan para sa refund',
    },
    life: {
      key: 'Ang buhay ng isang order',
      title: 'Anim na bagay ang nangyayari sa bawat order. Wala sa mga ito ang kailangan mong gawin.',
      pricedTitle: 'Pinepresyo sa server',
      pricedBody:
        'Ang dami mo ay pinepresyo ng parehong code na ginagamit ng API. Ang halagang inaprubahan mo ang siyang sinisingil.',
      chargedTitle: 'Isang beses lang sinisingil',
      chargedBody:
        'Binabawasan ang wallet mo sa oras na gawin ang order, at hindi na muli para sa order na iyon.',
      sentTitle: 'Ipinasa at sinusubaybayan',
      sentBody:
        'Iruruta sa provider na pinakamahusay maghatid para sa serbisyong iyon, tapos susubaybayan hanggang matapos.',
      deliveringTitle: 'Naghahatid',
      deliveringBody: 'Nakikita sa Climb: saan ka nagsimula, nasaan ka, at saan ka aabot sa bilis ngayon.',
      measuredTitle: 'Sinusukat sa 1, 7 at 30 araw',
      measuredBody:
        'Binabasa muli ang bilang na naihatid at ikinukumpara sa pagkatapos. Inilalathala ang porsiyentong natira.',
      settledTitle: 'Kusang nirerefill o nirerefund',
      settledBody:
        'Ang pagbaba sa loob ng refill window ay awtomatikong nagpapadala ng refill. Ang kulang na paghahatid ay ibinabalik sa wallet mo.',
    },
    kept: {
      key: 'Bakit hindi kami ang pinakamura',
      title: 'Ang pinakamurang follower ay ang nananatili.',
      body: 'Ang mas murang presyo na nawawalan ng ikatlo ng naihatid ay mas mahal kada follower na natitira kaysa sa mas mahal na nananatili. Bawat order ay iniruruta batay sa presyo kada natitirang unit, hindi sa nakasulat na presyo, at nakalagay sa serbisyo ang retention figure para makita mo.',
      link: 'Ang buong sagot, nasa FAQ',
      sticker: 'Nakasulat na presyo',
      held: 'Natira sa 30 araw',
      effective: 'Kada 1,000 na natira',
      cheaper: 'Ang mas murang listing',
      ours: 'Ang pinipili namin',
      foot: 'Halimbawang datos. Ang totoo ay nasa bawat serbisyo, kasama ang sample size.',
    },
    steps: {
      fundsTitle: 'Maglagay ng pondo',
      fundsBody: 'Card, o GCash, Maya at GrabPay sa Pilipinas. Walang subscription.',
      pickTitle: 'Pumili ng serbisyo',
      pickBody:
        'Piliin ang gusto mo, i-paste ang public link, at makikita mo ang eksaktong kabuuan bago mo kumpirmahin.',
      watchTitle: 'Panoorin itong umakyat',
      watchBody:
        'Live na sinusubaybayan ang paghahatid. Kulang na order ay kusang nirerefund; pagbaba ay kusang nirerefill.',
    },
    cta: {
      title: 'Handa kami kapag handa ka na.',
      body: 'Walang subscription, walang minimum na gastos, at hindi kailanman hihingin ang password mo.',
      account: 'Gumawa ng account',
    },
  },

  services: {
    key: 'Mga Serbisyo',
    titleA: 'Bawat serbisyo,',
    titleB: 'bawat presyo.',
    lede: 'Isang nakakalibrang price axis kada resulta, kaya ang pagkakalat ng mga marka ang mismong merkado. Lahat ng presyo ay kada 1,000 units, at walang idinadagdag sa checkout. I-click ang isang row para presyuhan ang totoong dami.',
    quality: 'Kalidad',
    region: 'Rehiyon',
    anyQuality: 'Kahit anong kalidad',
    anyRegion: 'Kahit saang rehiyon',
    allPlatforms: 'Lahat ng platform',
    search: 'Maghanap ng serbisyo',
    refillOnly: 'May refill lang',
    sort: 'Ayusin',
    sortPrice: 'Presyo',
    sortRetention: 'Retention',
    sortName: 'Pangalan',
    empty: 'Walang tugmang serbisyo',
    emptyBody: 'Subukan ang ibang paghahanap o alisin ang mga filter.',
    showEverything: 'Ipakita lahat',
    priceIt: 'Presyuhan',
    priceEmpty:
      'I-click ang kahit anong row at lilitaw dito ang presyo para sa totoong dami — ang mismong halagang sisingilin ng order form.',
    order: 'I-order ito',
    orderGuest: 'Gumawa ng account para mag-order',
    includes: 'Ano ang kasama sa presyo',
    terms: {
      perThousandTitle: 'Ang presyo ay kada 1,000 units',
      perThousandBody:
        'Pare-pareho ang paraan ng pagpepresyo, kaya direktang maikukumpara ang kahit alin. Ang $1.23 ay para sa 1,000; ang 500 ay kalahati niyan.',
      totalTitle: 'Kinakalkula ang kabuuan bago mo kumpirmahin',
      totalBody:
        'Ang dami mo ay pinepresyo sa server namin at ipinapakita nang buo. Ang halagang inaprubahan mo ang sisingilin — walang idinadagdag sa checkout.',
      balanceTitle: 'Nagdadagdag ka ng balanse, hindi subscription',
      balanceBody:
        'Maglagay ng pondo kapag kailangan mo at gastusin mula doon. Walang paulit-ulit na bayad, walang buwanang minimum.',
      refundTitle: 'Kusang nirerefund ang kulang na order',
      refundBody:
        'Kapag kulang ang naihatid, ang hindi naihatid ay kusang babalik sa balanse mo. Hindi mo kailangang mapansin o mag-open ng ticket.',
      refillTitle: 'Maraming serbisyo ang may refill window',
      refillBody:
        'Kapag may refill ang serbisyo, nakasulat ang haba nito sa row, at kami na ang magpapadala ng refill kapag may nakitang pagbaba ang retention check.',
    },
  },

  auth: {
    signInKey: 'Mag-sign in',
    signInTitle: 'Maligayang pagbabalik.',
    signInLede: 'Nandiyan pa rin ang mga order, balanse at lahat ng umaakyat pa.',
    identifier: 'Username o email',
    password: 'Password',
    passwordPlaceholder: 'Ang password mo',
    passkey: 'Mag-sign in gamit ang passkey',
    or: 'o',
    forgot: 'Nakalimutan?',
    remember: 'Manatiling naka-sign in nang 30 araw',
    newHere: 'Bago dito?',
    createAccount: 'Gumawa ng account',
    show: 'Ipakita',
    hide: 'Itago',

    registerKey: 'Gumawa ng account',
    registerTitle: 'Mag-order sa wala pang isang minuto.',
    registerLede: 'Username at password lang ang kailangan.',
    registerCarries: 'Naghihintay sa kabila ang serbisyong pinili mo.',
    registerClosed: 'Sarado muna ang pagpaparehistro. Balikan mo na lang mamaya.',
    username: 'Username',
    usernameHint: 'Mga letra, numero, tuldok, gitling at underscore.',
    newPassword: 'Password',
    newPasswordPlaceholder: 'Hindi bababa sa 10 karakter',
    noEmailTitle: 'Hindi kailangan ng email para magsimula',
    noEmailBody:
      "Puwede kang magdagdag sa checkout. Hangga't wala, hindi namin mababawi ang account mo, kaya ang account na walang email ay tinatanggal pagkalipas ng 5 araw. Ang pagdagdag ng email ay nagpapanatili nito — at ang anumang binayaran mo ay hindi kailanman awtomatikong tinatanggal.",
    agreeA: 'Sumasang-ayon ako sa',
    terms: 'Mga Tuntunin ng Serbisyo',
    agreeB: 'at',
    privacy: 'Patakaran sa Privacy',
    haveAccount: 'May account ka na?',

    caseKey: 'Paano ang pag-order dito',
    caseTitle: 'Paglagong nakikita mo.',
    caseNoEmailTitle: 'Hindi kailangan ng email para magsimula',
    caseNoEmailBody:
      'Username at password lang. Puwede kang magdagdag ng email sa checkout, kung saan resibo ito at hindi hadlang.',
    casePricedTitle: 'Pinepresyo bago mo kumpirmahin',
    casePricedBody:
      'Bawat kabuuan ay kinakalkula sa server namin at ipinapakita nang buo. Ang halagang inaprubahan mo ang sisingilin.',
    caseSettledTitle: 'Kusang nirerefund o nirerefill',
    caseSettledBody:
      'Ang kulang na paghahatid ay babalik sa wallet mo nang walang ticket. Ang pagbaba sa loob ng refill window ay kami na ang bahala.',
    backToSite: 'Bumalik sa site',
  },

  upsell: {
    title: 'Gawin itong mukhang organic',
    sameLink: 'Lahat dito ay ihahatid sa parehong link ng order sa itaas.',
    why: {
      likesForPlays: 'Ang plays na may kasamang likes ang nagpapamukha na sumisikat ang track.',
      likesForViews:
        'Ang video na may views pero walang likes ay mukhang binili. Ang likes na ilang porsyento ng views ay mukhang may nanood talaga.',
      viewsForLikes:
        'Kakaiba ang likes na walang views: walang nagla-like ng video na hindi nila napanood, at sa bagong video, halata ang ratio.',
      subsForViews:
        'Ilan sa bawat libong nanood ang nag-follow. Ang views na walang kasamang tao ay mukhang numero lang, hindi audience.',
      likesForFollowers:
        'Kapansin-pansin ang mga bagong follower na walang nila-like. Ilang likes sa mga bagong post ang nagpapamukha na tao ang paglago.',
      viewsForSubs:
        'Nanggagaling ang subscribers sa mga video na napanood. Ang views sa pinakabagong video ang nagpapa-make sense sa mga bagong subscriber.',
      likesForSubs: 'Ang nag-subscribe ay kadalasang may nila-like muna.',
      followersForPlays:
        'Ang plays mula sa mga nakinig na nag-follow pagkatapos ang nagpapamukha na sumisikat ang track.',
      likesForComments:
        'Halata kapag mas marami ang comments kaysa likes. Karamihan ng nagko-comment ay nagla-like din.',
      likesForShares: 'Bihira ang shares na walang likes; ang likes ang nagpapaniwala sa shares.',
      viewsForReactions:
        'Kapansin-pansin ang reactions sa post na kakaunti ang nakakita. Views muna, saka mukhang totoo ang reactions.',
    },
  },

  guest: {
    orderWithout: 'Mag-order nang walang account',
    orderTitle: 'Mag-order bilang guest',
    orderLede:
      'Magbayad, at nakalagay na ang order. May one-click link ang resibo sa email para gumawa ng account na nasa loob na ang order na ito.',
    email: 'Email para sa resibo',
    emailHint: 'Dito ipapadala ang detalye ng order at ang link para gumawa ng account. Wala nang iba.',
    linkLabel: 'Link o username',
    linkHint: 'Link sa public na profile o post. Hindi mahahatid sa private na account.',
    payWith: 'Magbayad gamit ang',
    noMethods: 'Ina-ayos pa ang mga pagbabayad. Mag-sign in para mag-order mula sa balanse mo.',
    pay: 'Magbayad ng {amount}',
    methods: {
      xenditPhLabel: 'GCash, Maya at bank transfer',
      xenditPh: 'Pati GrabPay, ShopeePay at over-the-counter sa 7-Eleven',
      xenditId: 'OVO, DANA, bank transfer at retail outlets',
      local: 'Sisingilin sa {currency} · walang conversion',
    },
    feeNote: 'Kasama ang {fee} na bayad sa {method}, para buong bayad ang order.',
    minimumNote:
      'Ang minimum para sa paraang ito ay {amount}; mananatili ang sobra bilang balanse sa account mo.',
    basket: 'Basket',
    haveAccount: 'May account ka na?',
    status: {
      eyebrow: 'Ang order mo',
      waitingTitle: 'Kinukumpirma ang bayad mo.',
      waitingLede:
        'Sinasabi sa amin ng payment processor na natuloy ito. Ilang segundo lang ito karaniwan; kusang mag-a-update ang page.',
      placedTitle: 'Nakalagay na ang order mo.',
      placedLede:
        'Kusang magsisimula ang paghahatid. Papunta na ang resibo sa email mo, kasama ang link na gagawa nitong account mo.',
      failedTitle: 'Hindi natuloy ang bayad.',
      failedLede: 'Walang siningil at walang inilagay. Puwede kang magsimula ulit kahit kailan.',
      canceledLede: 'Kinansela ang bayad bago matapos. Walang siningil.',
      reference: 'Reference',
      paid: 'Binayaran',
      email: 'Resibo sa',
      polling: 'Hinihintay ang processor…',
      failedItems:
        '{count} item ang hindi nailagay. Nakahawak ang pera bilang balanse sa account mo; ipinapaliwanag sa email.',
      nextKey: 'Susunod',
      nextBody:
        'Buksan ang email at i-click ang "Create my account". Pipili ka ng username at password, at makikita mo na ang mga order — may live na paghahatid, refill at refund na kami ang bahala. 30 araw ang bisa ng link.',
      help: 'Help centre',
      tryAgain: 'Subukan ulit',
      notFound: 'Hindi namin mahanap ang bayad na iyon.',
    },
    claim: {
      key: 'Gumawa ng account',
      loading: 'Sandali lang…',
      title: 'Pumili ng username at password.',
      lede: 'Iyon lang. Nasa account na ito ang {count} bayad na order mo.',
      emailConfirmed: 'Kumpirmado ang {email} — na-click mo ang link na ipinadala namin dito.',
      submit: 'Gumawa ng account at tingnan ang mga order',
      invalidTitle: 'Expired na ang link na ito.',
      invalidLede:
        '30 araw ang bisa ng claim link. Kung nakagawa ka na ng account, mag-sign in; kung hindi, magtanong sa help centre at banggitin ang order number mo.',
    },
  },

  footer: {
    tagline: 'Paglagong nakikita mo.',
    blurb:
      'Mag-browse ng mga serbisyo sa social media na may malinaw na presyo at pagsubaybay sa order. Nakadepende sa serbisyo ang tantiyang delivery, saklaw ng refill at pagiging kwalipikado sa refund.',
    startKey: 'Magsimula sa wala pang isang minuto',
    createAccount: 'Gumawa ng account',
    getHelp: 'Humingi ng tulong',
    startNote:
      'Sapat na ang username at password. Dumadaan ang suporta sa mga ticket, nakakabit na sa account at mga order mo.',
    product: 'Produkto',
    help: 'Tulong',
    legal: 'Legal',
    platforms: 'Mga platform',
    pricing: 'Presyo',
    signIn: 'Mag-sign in',
    helpCentre: 'Help centre',
    terms: 'Mga tuntunin ng serbisyo',
    privacy: 'Patakaran sa privacy',
    rights: '© {year} {site}. Nakalaan ang lahat ng karapatan.',
    mono: 'Presyo kada 1,000 · suriin ang total bago magbayad',
    notAffiliated: 'Hindi kaugnay ng anumang social media platform.',
    top: 'Itaas',
  },

  faq: {
    eyebrow: 'Help centre',
    titleA: 'Ang mga dapat itanong',
    titleEm: 'bago',
    titleB: 'ka magbayad',
    lede: 'Kasama ang mga may hindi komportableng sagot. Kung wala rito, magtanong — lumalaki ang listahang ito mula sa mga tunay na tanong ng mga tao.',
    searchPlaceholder: 'Maghanap sa {count} tanong',
    searchLabel: 'Maghanap ng tanong',
    clearSearch: 'Burahin ang hinahanap',
    try: 'Subukan',
    suggestions: 'refund, password, GCash, kanselahin, bumaba',
    topics: 'Mga paksa',
    ofTotal: 'sa {total}',
    inTopic: 'sa {topic}',
    matching: 'tumutugma sa “{query}”',
    showAll: 'Ipakita lahat',
    emptyTitle: 'Walang tumutugma sa “{query}”.',
    emptyText:
      'Subukan ang ibang salita, o magtanong nang direkta — ang tanong na walang sagot ang nagpapalaki sa listahang ito.',
    previous: 'Nakaraan',
    next: 'Susunod',
    stillUnsure: 'Hindi pa rin sigurado? Mag-open ng ticket',
    contactKey: 'Stuck pa rin?',
    contactTitle: 'Tanungin ang mga taong nagpapatakbo nito',
    contactText:
      'Dumadaan ang suporta sa mga ticket sa loob ng panel, hindi sa inbox. Umaabot ito sa parehong mga tao, at dumarating na nakakabit sa account at mga order mo — kaya walang kailangang humingi sa iyo ng order number.',
    contactNote: 'Wala pang account? Username at password lang ang kailangan, at mga tatlumpung segundo.',
    openTicket: 'Mag-open ng ticket',
    createAccount: 'Gumawa ng account',
    groups: {
      quality: {
        label: 'Kalidad at pagbaba',
        blurb: 'Kung nananatili sila, at ano ang ginagawa namin kapag hindi.',
      },
      orders: { label: 'Mga order', blurb: 'Bilis, link, kulang na delivery at pagkansela.' },
      money: { label: 'Mga bayad', blurb: 'Pagbabayad, presyong pang-rehiyon at ang wallet mo.' },
      account: {
        label: 'Account at kaligtasan',
        blurb: 'Password, panganib sa platform, pag-sign up, data mo.',
      },
    },
    q: {
      retention: {
        q: 'Nananatili ba ang mga followers, o nawawala?',
        a1: 'May bumababa. Kung may nagsasabing hindi, may ibinebenta sila sa iyo — nabubura ang mga account, nag-a-unfollow ang mga tao, at tinatanggal ng mga platform ang pekeng engagement nang sabay-sabay.',
        a2: 'Ang pagkakaiba rito ay sinusukat namin ito. Bawat natapos na order ay muling sinusuri sa 1, 7 at 30 araw at ikinukumpara ang naihatid na bilang sa bilang noong natapos. Kapag sapat na ang data, nakasulat sa order form sa tabi ng presyo ang porsyentong nanatili, kasama kung ilang order ang sinukat.',
        a3: 'Inilalathala namin ang numerong iyon kahit masama. Ang serbisyong nananatili sa 78% ay ipinapakitang 78%.',
      },
      refill: {
        q: 'Ano ang mangyayari kapag bumaba ang order ko?',
        a1: 'Sa serbisyong may refill guarantee, kami na ang nagpapadala ng refill. Hindi mo kailangang mapansin, at hindi mo kailangang humiling — ang parehong pagsukat na nagbibigay ng retention figure ang nagpapa-trigger ng kapalit.',
        a2: 'Ito ang pinakakaraniwang reklamo sa industriyang ito: refill guarantee na ibinenta at tahimik na binalewala kapag may gustong gumamit. Ang pag-alis ng paghiling ang mismong punto.',
      },
      qualityVsPrice: {
        q: 'Bakit hindi kayo ang pinakamura?',
        a1: 'Dahil ang pinakamura ay kadalasang hindi ang pinakamura. Ang isang libong followers na mas mura pero nawawalan ng ikatlo ay mas mahal kada follower na natitira kaysa sa mas mahal na nananatili.',
        a2: 'Inihahatid namin ang bawat order batay sa presyo kada follower na nananatili, hindi sa nakasulat na presyo, at ang parehong lohika ang nagtatakda ng singil namin. Minsan kami nga ang pinakamura; kapag hindi, ang pagkakaiba ay pambili ng delivery na nananatili.',
      },
      speed: {
        q: 'Gaano kabilis magsimula ang order?',
        a1: 'Karamihan ng serbisyo ay nagsisimula sa loob ng ilang minuto. Ipinapakita ng bawat isa ang karaniwang oras ng pagsisimula at bilis nito sa order form, mula sa tunay na ginagawa ng serbisyong iyon at hindi sa pangako.',
        a2: 'Ang order na hindi pa gumagalaw ay nakikita sa listahan ng mga order mo kasama ang live status nito, at mae-email ka kapag natapos.',
      },
      partial: {
        q: 'Paano kung bahagi lang ng order ang naihatid?',
        a1: 'Kusang nirerefund ang hindi naihatid na bahagi, sa presyong binayaran mo, at bumabalik ang pera sa wallet mo nang hindi mo hinihiling. Ang ganap na nabigong order ay nirerefund nang buo sa parehong paraan.',
        a2: 'Kinakalkula ang refund mula sa order at isinusulat sa ledger ng sistema, hindi ng taong nagpapasya kung tutuparin.',
      },
      cancel: {
        q: 'Puwede ko bang kanselahin ang order?',
        a1: 'Sa mga serbisyong sumusuporta sa pagkansela, oo — lumalabas ang opsyon sa order mismo. Maraming serbisyo ang hindi na makakansela kapag nagsimula na ang delivery, at sinasabi ng order form kung alin bago ka bumili, hindi pagkatapos.',
      },
      link: {
        q: 'Anong link ang ibibigay ko?',
        a1: 'Kung ano ang hinihingi ng serbisyo: profile URL para sa followers, post URL para sa likes o views, minsan username lang. Sinasabi ng field kung alin at tinatanggihan ang maling hugis bago ka magbayad, hindi nabibigo pagkatapos.',
        a2: 'Dapat public ang account mo habang tumatakbo ang order. Hindi makakatanggap ng delivery ang private account, at hindi iyon maaayos ng refill.',
      },
      payment: {
        q: 'Paano ako magbabayad?',
        a1: 'Card, at mga lokal na paraan ng pagbabayad kung saan sinusuportahan namin — sa Pilipinas, GCash, Maya at GrabPay.',
        a2: 'Pumapasok muna ang pera sa wallet balance, at kumukuha rito ang mga order. Ibig sabihin, hindi kailanman naghihintay ang order sa pag-clear ng bayad, at agad na dumarating ang refund sa halip na ibalik sa card network.',
      },
      regional: {
        q: 'Bakit mas mababa ang presyo sa ilang bansa?',
        a1: 'Dahil ang presyong makatuwiran sa London ay hindi makatuwiran sa Maynila. Ang mga customer na nagbabayad mula sa suportadong bansa ay may lokal na listahan ng presyo.',
        a2: 'Nakukuha ito sa pamamagitan ng paraan ng pagbabayad, hindi sa kung saan ka mukhang nagba-browse — lokal na e-wallet o card na inisyu sa bansang iyon. Mas patas iyon kaysa sa location detection, na madaling pekein at maling maghaharang sa mga nagtatrabaho sa ibang bansa na bumibili para sa pamilya sa bahay.',
      },
      refundWallet: {
        q: 'Puwede ko bang i-withdraw ang wallet balance ko?',
        a1: 'Ang pera sa wallet ay para sa mga order at hindi puwedeng i-withdraw. Mag-deposito ng balak mong gastusin sa halip na mag-ipon ng balanse.',
        a2: 'Anumang nirefund mula sa nabigo o kulang na order ay bumabalik sa wallet at puwedeng gastusin sa iba.',
      },
      password: {
        q: 'Kailangan ba ninyo ang password ko?',
        a1: 'Hindi. Kailanman. Public link o username lang ang hinihingi namin at wala nang iba.',
        a2: 'Anumang serbisyo saanman na humihingi ng password mo sa social media ay kinokompromiso ang account mo o malapit nang gawin. Walang lehitimong dahilan para rito.',
      },
      safe: {
        q: 'Ligtas ba ito para sa account ko?',
        a1: 'Hindi namin kailanman hinahawakan ang login mo, at nangyayari ang delivery mula sa labas ng account mo. Ang tapat na babala: labag sa terms of service ng bawat malaking platform ang pagbili ng engagement, at sa kanila ang pagpapatupad, hindi sa amin.',
        a2: 'Sa praktika: panatilihing proporsyonal ang mga order sa laki ng account mo, iwasang umorder ng parehong bagay nang paulit-ulit sa maikling panahon, at ituring na panganib ang anumang mukhang biglaan. Ang dahan-dahang paglago ay mukhang dahan-dahang paglago.',
      },
      signup: {
        q: 'Bakit puwede akong mag-sign up nang walang email?',
        a1: 'Para makapag-order ka sa wala pang isang minuto. Sapat na ang username at password para magsimula.',
        a2: 'Totoo ang kapalit at sinasabi namin agad: kung walang email, hindi namin mababawi ang account mo o mapapadalhan ka ng resibo, kaya ang account na walang email ay tinatanggal pagkalipas ng 5 araw. Ang pagdaragdag ng email anumang oras ay nagpapanatili nito. Ang account na may balanse, order o bayad ay hindi kailanman kusang tinatanggal — ipinapasa ito sa tao.',
      },
      privacy: {
        q: 'Ano ang ginagawa ninyo sa data ko?',
        a1: 'Itinatago namin ang kailangan para tumakbo ang mga order mo at wala nang iba. Hindi namin ito ibinebenta, at wala kaming ipino-post kahit saan.',
        a2: 'Ang buong detalye ay nasa patakaran sa privacy, na isinulat para mabasa at hindi para tiisin.',
      },
    },
  },

  help: {
    key: 'Help centre',
    title: 'Tanungin ang mga taong nagpapatakbo nito.',
    lede: 'Walang inbox dito. Lahat ay nagiging ticket sa iisang queue na pinagtatrabahuhan ng staff namin, at hindi mo kailanman kailangan ng email para matulungan, o para mabasa ang sagot.',
    points: {
      findTitle: 'Naka-lock out? Hanapin ang order mo',
      findBody:
        'Ang order number, ang username sa account, at ang huling apat na character ng payment reference ang nagpapatunay na sa iyo ito. Pagkatapos, makikita mo kung ano mismo ang nangyayari rito.',
      autoTitle: 'Karamihan ng sagot ay hindi nangangailangan ng tao',
      autoBody:
        'Ang kulang na delivery ay kusang nagre-refund, ang pagbaba ay kusang nagre-refill, at sinasabi ng order page kung alin ang nangyari. Kapag kailangan na ng tao, ipasa mula sa parehong screen.',
      repliesTitle: 'Nasa ticket ang mga sagot',
      repliesBody:
        'Kapag naka-sign in, sa ilalim ng Support. Kapag hindi, sa page na binubuksan ng number at key. Walang ini-email, at hindi kami kailanman humihingi ng password sa social media.',
    },
    asideGuest:
      'May account at natatandaan ang password? {link} at itatago ang mga ticket sa ilalim ng Support para sa iyo.',
    asideGuestLink: 'Mag-sign in',
    asideUser: 'Nasa {link} ang mga ticket mo, katabi ng mga order mo.',
    asideUserLink: 'Support',
    laneOrder: 'Hanapin ang order ko',
    laneTicket: 'Mag-open ng ticket',

    findFailed: 'Hindi namin maitugma ang mga detalyeng iyon sa isang order.',
    refreshFailed: 'Hindi ma-refresh ang order',
    orderNumber: 'Order number',
    orderNumberPlaceholder: 'hal. 1042',
    orderNumberHint: 'Nakikita sa order page at sa confirmation.',
    username: 'Username sa account',
    usernamePlaceholder: 'pangalanmo',
    last4: 'Huling apat na character ng payment reference',
    last4Placeholder: 'hal. 9QX2',
    last4Hint:
      'Anumang natapos na deposito sa account. Ganito ang hitsura ng reference: PAY-7F3K9QX2, sa wallet page at mga resibo.',
    findOrder: 'Hanapin ang order',
    findFoot:
      'Walang payment reference sa kamay? Mag-open na lang ng ticket at ibigay ang order number; may taong magbeberipika nito kasama mo.',

    status: {
      PENDING: 'Nakapila',
      QUEUED: 'Nakapila',
      SUBMITTING: 'Ipinapasa',
      PROCESSING: 'Pinoproseso',
      IN_PROGRESS: 'Naghahatid',
      PARTIAL: 'Bahagi lang',
      COMPLETED: 'Tapos na',
      CANCELED: 'Kinansela',
      FAILED: 'Nabigo',
      REFUNDED: 'Nirefund',
    },
    orderKey: 'Order #{number}',
    orderMeta: '{platform} · {quantity} inorder · {charge} · inilagay {date}',
    done: 'Tapos na',
    providerNote: 'Tala ng provider: {note}',
    refundedToWallet: 'Nirefund sa wallet',
    checkAfter: 'Pagsusuri pagkalipas ng {n} araw | Pagsusuri pagkalipas ng {n} araw',
    stillThere: '{held}% ang nananatili',
    due: 'sa {date}',
    refillAt: 'Refill {date}',
    ticketNumber: 'Ticket #{number}',

    escalatedTitle: 'Nasa tao na ang Ticket #{number}.',
    escalatedBody:
      'Nakatala ito sa ilalim ng order na ito at ng account. Binubuksan ito ng link na ito habang naka-lock out ka; ito lang ang kopya ng key.',
    copy: 'Kopyahin',
    copied: 'Nakopya',
    copyLink: 'Kopyahin ang link',
    openTheTicket: 'Buksan ang ticket',
    needPersonTitle: 'Kailangan pa rin ng tao?',
    needPersonBody:
      'Ipasa ang order na ito sa support. Nakikita nila ang lahat sa itaas, pati ang panig ng provider.',
    escalate: 'Ipasa sa tao',
    escalateLabel: 'Ano ang dapat nilang malaman?',
    escalatePlaceholder:
      'Ang inaasahan mo, ang nakikita mo, at anumang hindi ipinapaliwanag ng mga numero sa itaas.',
    reachYou: 'Paraan para maabot ka',
    reachYouEscPlaceholder: 'Opsyonal: isang handle. Lalabas ang mga sagot sa ticket kahit ano pa.',
    escalateFailed: 'Hindi ma-open ang ticket',

    emailAttached: 'Naikabit na ang email.',
    noEmailTitle: 'Walang email address ang account na ito.',
    noEmailBody:
      'Magkabit ng isa at mare-reset ang password sa normal na paraan. Doon lang ito ginagamit at para sa mga resibo.',
    attachEmail: 'Magkabit ng email',
    emailLabel: 'Email para sa account na ito',
    emailPlaceholder: "ikaw{'@'}example.com",
    attachSend: 'Ikabit at magpadala ng verification',
    attachFailed: 'Hindi maikabit ang email na iyon',
    viewStays: 'Bukas ang view na ito sa loob ng 30 minuto.',
    refreshOrder: 'I-refresh ang order',

    yourTickets: 'Mga bukas mong ticket',
    ticketOpened: 'Na-open ang ticket',
    queuedTitle: 'Ikaw ang {number} sa pila.',
    queuedToast: 'Nasa pila na ang #{number}.',
    sentLede:
      'Naabisuhan na ang staff. Binubuksan ng link na ito ang ticket mo, ipinapakita ang bawat sagot, at hinahayaan kang sumagot. Ito lang ang kopya ng key mo, kaya itago sa ligtas na lugar.',
    sendAnother: 'Magpadala ng isa pa',
    sentNote:
      'Natatandaan din ng browser na ito ang key, kaya gagana ang pagbabalik sa ticket page dito kahit walang link.',
    yourName: 'Pangalan mo',
    yourNamePlaceholder: 'Ano ang itatawag namin sa iyo?',
    reachYouPlaceholder: 'Opsyonal: isang handle, o ang username mo rito',
    reachYouHint: 'Kung gusto mo lang. Lalabas ang mga sagot sa ticket kahit ano pa.',
    about: 'Tungkol ito sa',
    topic: 'Paksa',
    topics: {
      ORDER: 'Isang order',
      PAYMENT: 'Isang bayad',
      ACCOUNT: 'Account ko',
      REFILL: 'Isang refill',
      OTHER: 'Iba pa',
    },
    subject: 'Paksa',
    subjectPlaceholder: 'Isang linya tungkol dito',
    message: 'Mensahe',
    messagePlaceholder:
      'Ano ang nangyari, ano ang inaasahan mo, at anumang makakatulong para mahanap namin: order number, link, oras.',
    messageHint: 'Nakakatulong ang order number at link. Password, hindi kailanman — hindi kami hihingi.',
    submitGuest: 'Mag-open ng ticket',
    submitUser: 'Mag-open ng ticket sa ilalim ng account ko',
    sendFailed: 'Hindi maipadala ang mensahe mo',
    faqFoot:
      'Naghahanap muna ng sagot? Sakop ng {link} ang mga tanong na talagang itinatanong ng mga tao, kasama ang mga hindi komportableng sagot.',
    faqFootLink: 'FAQ',
  },

  ticket: {
    number: 'Ticket #{number}',
    opening: 'Binubuksan…',
    needsKey: 'Kailangan ng ticket na ito ang key nito.',
    wrongKey: 'Hindi binubuksan ng key na iyon ang ticket na ito.',
    needsKeyBody:
      'Dala ito ng link na ibinigay sa iyo noong nag-open ka ng ticket. I-paste sa ibaba ang key mula sa link na iyon.',
    mismatch: 'Hindi magkatugma ang ticket number at key na iyon.',
    keyLabel: 'Key',
    keyPlaceholder: 'I-paste ang key mula sa link mo',
    openTicket: 'Buksan ang ticket',
    lostKey:
      'Nawala ang key? Hindi ito mababawi. {link} at banggitin ang #{number} para maipagsama namin ang dalawa.',
    lostKeyLink: 'Mag-open ng bagong ticket',
    status: {
      OPEN: 'Bukas',
      PENDING_SUPPORT: 'Hinihintay ang support',
      PENDING_CUSTOMER: 'Hinihintay ka',
      RESOLVED: 'Nalutas',
      CLOSED: 'Sarado',
    },
    opened: 'Binuksan {date}',
    with: 'kasama si {name}',
    staff: '{name} · Support',
    you: 'Ikaw',
    reply: 'Sumagot',
    replyPlaceholder: 'Magdagdag ng anumang makakatulong, o sagutin ang tanong ng support.',
    repliesHere: 'Lalabas dito ang mga sagot; walang ini-email.',
    sendReply: 'Ipadala ang sagot',
    sendFailed: 'Hindi maipadala ang sagot mo',
    closed: 'Sarado na ang ticket na ito. Kung may mali pa rin, {link} at banggitin ang #{number}.',
    closedLink: 'mag-open ng bago',
  },

  legal: {
    updated: 'Na-update {date}',
    sections: '{n} seksyon | {n} seksyon',
    minRead: '{n} min na basahin',
    contents: 'Nilalaman',
    plainWords: 'Sa simpleng salita',
    keepReading: 'Magpatuloy sa pagbabasa',
    backToTop: 'Bumalik sa itaas',
  },
}
